import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

// Actions
import { updateQueryString } from 'services/router/actions';
import { makeSelectFilteredSelectedTimesheets } from 'services/timesheets/selectors';
import { AppState } from 'services/types';

interface DispatchProps {
    updateQueryString: Function;
}

interface ConnectedProps {
    timesheets?: number[];
}

type Props = DispatchProps & ConnectedProps;

export class SubmitMutipleTimesheetsDropdownItem extends React.PureComponent<
    Props
> {
    handleClick = (): void => {
        this.props.updateQueryString({
            submitMultipleTimesheetsModal: true
        });
    };

    render(): React.ReactElement | null {
        const { timesheets } = this.props;

        if (!timesheets || !timesheets.length) return null;

        return <Dropdown.Item text="Submit" onClick={this.handleClick} />;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheets: makeSelectFilteredSelectedTimesheets()
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(SubmitMutipleTimesheetsDropdownItem);
